const SIGNABLE_MIME_TYPES = ["application/pdf", "image/jpeg", "image/png"]
const SIGNABLE_EXTENSIONS = ["pdf", "jpg", "jpeg", "png"]

export const SIGNABLE_ACCEPT = SIGNABLE_MIME_TYPES.join(",")

const extensionOf = (name: string | undefined) => {
  const parts = name?.split(".") ?? []
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : ""
}

/** Only narrows the offer; the server decides by the file's own bytes. */
export const isSignableFile = (
  mimeType: string | undefined,
  name: string | undefined
) =>
  mimeType
    ? SIGNABLE_MIME_TYPES.includes(mimeType.toLowerCase())
    : SIGNABLE_EXTENSIONS.includes(extensionOf(name))

export const isHeic = (file: { type?: string; name?: string }): boolean =>
  /^image\/hei[cf]/i.test(file.type ?? "") ||
  /\.hei[cf]$/i.test(file.name ?? "")
